module.exports = __webpack_public_path__ + "img/more-icon.a5f3757a.svg";